import { Box, Typography } from '@mui/material';
import { AssetLinks } from '@/pages/ValuationsV2/components/AssetDetails/AssetsLinks';
import { useValuationsStore } from '../../store/valuationsStore';
import { UpdatedAt } from '../UpdatedAt';

const styles = {
  name: {
    fontFamily: 'Roboto',
    fontSize: '1.8rem',
    textWrap: 'balance',
    whiteSpace: 'wrap',
    fontWeight: '400',
    '@media (max-width: 1280px)': {
      fontSize: '1.5rem',
    },
  },
};

const AssetDetailsHeader = () => {
  const selectedAsset = useValuationsStore.use.selectedAssetDetails();
  const disabled = selectedAsset === null;

  return (
    <>
      <Box display='flex' flexDirection='column'>
        <Typography sx={styles.name} variant='h1' data-id='asset-details-name'>
          {disabled || !selectedAsset ? '-' : selectedAsset.displayName}
        </Typography>
      </Box>

      <Box
        sx={{ marginTop: 'auto', width: '100%' }}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <AssetLinks />
        <UpdatedAt date={selectedAsset?.reportUpdatedDate} />
      </Box>
    </>
  );
};

export { AssetDetailsHeader };
